import gql from 'graphql-tag'

export default gql`mutation go($client_id: Int!, $ids: [Int]!) {
  removeClientContacts(client_id: $client_id, ids: $ids) {
    client_id
    name
    date_created
    client_type_id
    client_type{
      client_type_id
      description
    }
    addresses{
      address_id
      full_address
    }
    contacts{
      contact_id
      first_name
      last_name
      position
      communication_methods{
        communication_method_id
        contact_info
        contact_medium_id
        contact_medium{
          contact_medium_id
          description
        }
      }
    }
    client_communication_methods{
      communication_method_id
      contact_info
      contact_medium_id
      contact_medium{
        contact_medium_id
        description
      }
    }
    projects{
      project_id
      name
      project_status{
        project_status_id
        description
      }
    }
    minutes_worked_on_all_projects
  }
}
`